import {
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { QuantityString } from 'model/Quantity'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CuttingPlanDetailsDto } from '../../../services/APIs/InternalAPI/internal-api.contracts'

const useStyles = makeStyles(() =>
  createStyles({
    center: {
      textAlign: 'center',
    },
  })
)

export function CuttingPlanDetails(props: {
  details: CuttingPlanDetailsDto
  size?: 'small' | 'medium'
}) {
  const classes = useStyles()
  const { t } = useTranslation()

  if (!props.details) {
    return null
  }

  return (
    <Table size={props.size || 'medium'}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.center}>
            {t('project:material-dimensions', 'material dimensions')}
          </TableCell>
          <TableCell className={classes.center}>
            {t('project:material-area', 'material area')}
          </TableCell>
          <TableCell className={classes.center}>
            {t('project:material-utilization', 'material utilization')}
          </TableCell>
          <TableCell className={classes.center}>
            {t('project:material-nestable-area', 'nestable area')}
          </TableCell>
          <TableCell className={classes.center}>
            {t(
              'project:material-nestable-area-utilization',
              'nestable area utilization'
            )}
          </TableCell>
          <TableCell className={classes.center}>
            {t('project:material-parts', 'parts')}
          </TableCell>
          <TableCell className={classes.center}>
            {t('project:material-uniq-parts', 'uniq parts')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.sheetLength,
              unit: 'mm',
            })}
            {' x '}
            {QuantityString({
              value: props.details.sheetWidth,
              unit: 'mm',
            })}
          </TableCell>

          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.sheetArea,
              unit: 'mm²',
            })}
          </TableCell>
          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.sheetUtilization,
              unit: '%',
            })}
          </TableCell>
          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.nestableArea,
              unit: 'mm²',
            })}
          </TableCell>

          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.offsettedSheetUtilization,
              unit: '%',
            })}
          </TableCell>
          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.totalPartQuantity,
              unit: '',
            })}
          </TableCell>
          <TableCell className={classes.center}>
            {QuantityString({
              value: props.details.uniquePartQuantity,
              unit: '',
            })}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}
